import { render, staticRenderFns } from "./lgsecrethistory.vue?vue&type=template&id=7ab47a73&"
import script from "./lgsecrethistory.vue?vue&type=script&lang=js&"
export * from "./lgsecrethistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports